import '../styles/custom-alert.css'
const CustomAlert = ({children,type}) => {
  return (
    <div className={`custom-alert__wrapper ${type ? `custom-alert__wrapper--${type}` : ''}`}>
        {children}
    </div>
  )
}

export default CustomAlert